import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatIconModule } from '@angular/material/icon';
import { MatTooltipModule } from '@angular/material/tooltip';
import { SweetAlert2Module } from '@sweetalert2/ngx-sweetalert2';
import { UiModule } from 'src/app/components/ui.module';
import { ReviewClipNotUsefulComponent } from '../review-clip-not-useful/review-clip-not-useful.component';
import { ReviewExpiredModalComponent } from '../review-expired-modal/review-expired-modal.component';
import { ReviewReportProblemComponent } from '../review-report-problem/review-report-problem.component';
import { ReviewSubmissionFailedModalComponent } from '../review-submission-failed-modal/review-submission-failed-modal.component';
import { ReviewVideoClipsComponent } from '../shared/review-video-clips/review-video-clips.component';
import { ReviewFormErrorsInlineAlertComponent } from './review-form-errors-inline-alert/review-form-errors-inline-alert.component';
import { ReviewFormExtraLinksComponent } from './review-form-extra-links/review-form-extra-links.component';
import { ReviewFormFindingsComponent } from './review-form-findings/review-form-findings.component';
import { ReviewFormNtfReasonComponent } from './review-form-ntf-reason/review-form-ntf-reason.component';
import { ReviewFormHeaderComponent } from './review-form-header/review-form-header.component';
import { ReviewIncidentDateComponent } from './review-form-incident-date/review-form-incident-date.component';
import { ReviewFormIncidentPhotosComponent } from './review-form-incident-photos/review-form-incident-photos.component';
import { ReviewFormIncidentTypeComponent } from './review-form-incident-type/review-form-incident-type.component';
import { ReviewFormRecentWalkInsComponent } from './review-form-recent-walk-ins/review-form-recent-walk-ins.component';
import { ReviewFormSuspectedItemsComponent } from './review-form-suspected-items/review-form-suspected-items.component';
import { ReviewFormSuspectedTheftComponent } from './review-form-suspected-theft/review-form-suspected-theft.component';
import { ReviewFormSuspiciousIncidentReportOptionsComponent } from './review-form-suspicious-incident-report-options/review-form-suspicious-incident-report-options.component';
import { ReviewFormTemplateComponent } from './review-form-template/review-form-template.component';
import { ReviewFormTransactionReportsComponent } from './review-form-transaction-reports/review-form-transaction-reports.component';
import { ReviewFormValueAdditionalStolenItemsComponent } from './review-form-value-additional-stolen-items/review-form-value-additional-stolen-items.component';

const components = [
  ReviewFormIncidentTypeComponent,
  ReviewIncidentDateComponent,
  ReviewFormTemplateComponent,
  ReviewFormSuspectedItemsComponent,
  ReviewFormValueAdditionalStolenItemsComponent,
  ReviewFormIncidentPhotosComponent,
  ReviewFormTransactionReportsComponent,
  ReviewFormSuspectedTheftComponent,
  ReviewFormExtraLinksComponent,
  ReviewFormSuspiciousIncidentReportOptionsComponent,
  ReviewFormHeaderComponent,
  ReviewExpiredModalComponent,
  ReviewClipNotUsefulComponent,
  ReviewFormErrorsInlineAlertComponent,
  ReviewSubmissionFailedModalComponent,
  ReviewVideoClipsComponent,
  ReviewReportProblemComponent,
  ReviewFormFindingsComponent,
  ReviewFormRecentWalkInsComponent,
  ReviewFormNtfReasonComponent,
];

const standaloneImports = [];

@NgModule({
  declarations: [...components],
  exports: [...components, ...standaloneImports],
  imports: [
    CommonModule,
    FormsModule,
    ReactiveFormsModule,
    UiModule,
    MatIconModule,
    MatTooltipModule,
    SweetAlert2Module,
    ...standaloneImports,
  ],
})
export class ReviewFormModule {}
